import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    getAuctioneerDirectoryUrl,
    getAuctionResultsUrl,
    getAuctionsNearMePageUrl,
    getConsignmentsUrl,
    getHowAuctionsWorkUrl,
    getNewsUrl,
    getSupportUrl,
} from '@/utils/urls';
import { getBaseUrl } from '../../../redux/modules/config';
import { useAppSelector } from '@/redux/hooks';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

const LACrown = () => {
    const baseUrl = useAppSelector(getBaseUrl);

    return (
        <StyledCrown>
            <StyledCrownInner>
                <Link route secondary to={getAuctioneerDirectoryUrl()}>
                    <FormattedMessage id="crown.directory" />
                </Link>
                <Link route secondary to={getAuctionsNearMePageUrl()}>
                    <FormattedMessage id="crown.nearMe" />
                </Link>
                <Link route secondary to={getAuctionResultsUrl()}>
                    <FormattedMessage id="crown.priceResults" />
                </Link>
                <Link secondary target="_blank" to={getNewsUrl(baseUrl)}>
                    <FormattedMessage id="crown.news" />
                </Link>
                <Link rel="noopener" secondary target="_blank" to={getSupportUrl()}>
                    <FormattedMessage id="crown.help" />
                </Link>
                <Link route secondary to={getConsignmentsUrl()}>
                    <FormattedMessage id="crown.consign" />
                </Link>
                <Link route secondary to={getHowAuctionsWorkUrl()}>
                    <FormattedMessage id="crown.auctions" />
                </Link>
            </StyledCrownInner>
        </StyledCrown>
    );
};

// because baseUrl will never update we can keep memo
export default React.memo(LACrown);

const StyledCrown = styled.div`
    background-color: ${({ theme }) => theme.colors.beige100};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
    font-size: 12px;
    display: flex;
    padding: 7px 20px;

    @media (max-width: 767px) {
        font-size: 10px;
    }
`;

const StyledCrownInner = styled.div`
    flex: 1 1 auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.pageWidth}) {
        margin: 0 auto;
        max-width: ${({ theme }) => theme.breakpoints.pageWidth};
        padding: 0 20px;
    }

    & > * {
        padding-right: 2em;

        @media (max-width: 767px) {
            padding-right: 1em;
        }
    }

    & > a {
        &:hover {
            color: ${({ theme }) => theme.colors.black};
            text-decoration: underline;
        }
    }

    & > span {
        color: ${({ theme }) => theme.colors.grey300};
    }
`;
